(() => {
  let cachedSlider = null;
  let observer = null;
  let scheduled = false;

  function initSlider(root) {
    if (!root) return;
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    const track = root.querySelector("[data-track]");
    if (!track) return;

    const prev = root.querySelector('.gf-collection-blocks__nav[data-dir="-1"]');
    const next = root.querySelector('.gf-collection-blocks__nav[data-dir="1"]');

    const scrollByAmount = (dir) => {
      const amount = Math.max(160, Math.floor(track.clientWidth * 0.85));
      track.scrollBy({ left: dir * amount, behavior: "smooth" });
    };

    const updateNav = () => {
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      const canScroll = maxScrollLeft > 4;
      if (!canScroll) {
        if (prev) prev.setAttribute("disabled", "disabled");
        if (next) next.setAttribute("disabled", "disabled");
        root.classList.add("is-not-scrollable");
        return;
      }

      root.classList.remove("is-not-scrollable");
      if (prev) prev.toggleAttribute("disabled", track.scrollLeft <= 2);
      if (next) next.toggleAttribute("disabled", track.scrollLeft >= maxScrollLeft - 2);
    };

    if (prev) prev.addEventListener("click", () => scrollByAmount(-1));
    if (next) next.addEventListener("click", () => scrollByAmount(1));
    track.addEventListener("scroll", () => window.requestAnimationFrame(updateNav), { passive: true });
    window.addEventListener("resize", () => window.requestAnimationFrame(updateNav));

    updateNav();
  }

  function ensureCachedSlider() {
    if (cachedSlider && cachedSlider.isConnected) return cachedSlider;

    // Already inserted somewhere in DOM?
    const existing = document.querySelector("[data-gf-collection-blocks]");
    if (existing) {
      cachedSlider = existing;
      return cachedSlider;
    }

    // Otherwise, take it from the hidden source.
    const source = document.getElementById("gf-collection-blocks-source");
    if (!source) return null;
    const slider = source.querySelector("[data-gf-collection-blocks]");
    if (!slider) return null;

    // Move to body temporarily so we keep a single instance.
    document.body.insertBefore(slider, document.body.firstChild);
    source.remove();
    cachedSlider = slider;
    return cachedSlider;
  }

  function placeSliderInGfGrid() {
    const slider = ensureCachedSlider();
    if (!slider) return;

    const gfGrid = document.getElementById("gf-grid");
    if (!gfGrid) return;

    // Ensure it's the FIRST element in gf-grid.
    if (slider.parentElement !== gfGrid || gfGrid.firstElementChild !== slider) {
      gfGrid.insertBefore(slider, gfGrid.firstChild);
    }

    initSlider(slider);
  }

  function schedulePlace() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      placeSliderInGfGrid();
    });
  }

  function startObserver() {
    if (observer) return;
    observer = new MutationObserver(() => schedulePlace());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function insertCollectionBlocksSlider() {
    // Try now; if gf-grid is built later, observer/event will retry.
    schedulePlace();
    startObserver();
  }

  document.addEventListener("DOMContentLoaded", insertCollectionBlocksSlider);
  window.addEventListener("globoFilterRenderCompleted", insertCollectionBlocksSlider);
})();

